import { errorConstants } from "../_constants";

export const errorActions = {
    setError,
    hideError
};

// set error message
function setError(message){
    return {
        type: errorConstants.SET_ERROR,
        message
    };
}

// hide error message
function hideError(){
    return {
        type: errorConstants.HIDE_ERROR
    };
}